import React, { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';

import { Step } from '../types';

import { Button, ButtonIntent } from 'app/design-system/components/Button';
import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';

import { closeSigningDialog, openLoginDialog } from '../../Signing/actions';
import { StepContext } from '../contexts/stepContext';
import { UserContext } from '../contexts/userContext';
import SubmitFooterContent from './SubmitFooterContent';

import dictionary from './ModalFooter.dictionary.json';

import styles from '../RestorePasswordDialog.module.scss';

const ModalFooter = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { activeStep, backwardStep } = useContext(StepContext);
  const { userData: { requisite, disabled, checked } } = useContext(UserContext);

  const handleStepBack = useCallback(() => {
    if (activeStep === Step.INITIAL) {
      dispatch(openLoginDialog());
    }
    else if (activeStep === Step.DONE) {
      dispatch(closeSigningDialog());
      sessionStorage.removeItem('phone');
    }
    else {
      backwardStep(activeStep);
    }
  }, [activeStep, requisite]);

  const checkStep = activeStep === Step.DONE
    ? t(dictionary.close)
    : t(dictionary.back);

  return (
    <Modal.Footer>
      <Button intent={ButtonIntent.DEFAULT}
              className={styles.footerButton}
              disabled={disabled}
              onClick={handleStepBack}>
        {checkStep}
      </Button>
      <SubmitFooterContent activeStep={activeStep}
                           disabled={disabled}
                           checked={checked} />
    </Modal.Footer>
  );
};

export default ModalFooter;
